<mat-button-toggle
  [checked]="showShapeProjection$ | async"
  (click)="toggleProjection()"
  class="toolbar-button"
  [disabled]="(areProjectionsEnabled$ | async) === false"
  [matTooltip]="
    (areProjectionsEnabled$ | async) === false
      ? 'Projections are loading...'
      : 'Toggle 3D Shape Visibility'
  "
>
  <mat-icon [h3CustomIcon]="shapeProjectionIcon"></mat-icon>
</mat-button-toggle>
